export function MyTimeGutterHeader() {
  return <div className="timeGutterHeader">All day</div>;
}
